import React, { useState } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Link, Stack, TextField, Typography } from '@mui/material';
import api from '../../services/api';

// Conectar una tienda Shopify con la app creada en el Dev Dashboard de Shopify (dev.shopify.com) e instalada en la tienda.
// Con el Client ID y el Client Secret DashFlow pide un token cuando lo necesita: no hay que reconectar nunca.

const ShopifyConnectDialog: React.FC<{ onClose: () => void; onConnected: () => void }> = ({ onClose, onConnected }) => {
  const [form, setForm] = useState({ shop: '', clientId: '', clientSecret: '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [ok, setOk] = useState<string | null>(null);
  const save = async () => {
    setSaving(true);
    setError(null);
    try {
      const r = await api.connectShopify(form);
      setOk(`${r.shopName || r.shop}: ${r.message}`);
      setTimeout(onConnected, 1500);
    } catch (e: any) {
      setError(e?.response?.data?.message || 'No se pudo conectar');
    } finally {
      setSaving(false);
    }
  };
  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Conectar Shopify</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <Typography variant="body2" color="text.secondary">
            En <Link href="https://dev.shopify.com" target="_blank" rel="noreferrer">dev.shopify.com</Link> creá una app con permisos
            read_orders, read_all_orders, read_products y read_inventory, instalala en la tienda y copiá el Client ID y el Client Secret.
            Los pedidos entran solos cada 10 minutos; el stock de Shopify no se toca.
          </Typography>
          <TextField size="small" label="Tienda" placeholder="mitienda.myshopify.com" value={form.shop} onChange={e => setForm({ ...form, shop: e.target.value })} autoFocus />
          <TextField size="small" label="Client ID" value={form.clientId} onChange={e => setForm({ ...form, clientId: e.target.value })} />
          <TextField size="small" label="Client Secret" type="password" value={form.clientSecret} onChange={e => setForm({ ...form, clientSecret: e.target.value })} />
          {error && <Alert severity="error">{error}</Alert>}
          {ok && <Alert severity="success">{ok}</Alert>}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" onClick={save} disabled={saving || !form.shop || !form.clientId || !form.clientSecret}>Conectar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShopifyConnectDialog;
